import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Article from "@/pages/Article";
import Booking from "@/pages/Booking";
import Cancel from "@/pages/Cancel";
import LegalNotice from "@/pages/LegalNotice";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { CookieBanner } from "@/components/site/CookieBanner";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider } from "@/lib/auth";
import { MaintenanceGuard } from "@/components/site/MaintenanceGuard";

// Public pages are wrapped by MaintenanceGuard:
// non-admins see ComingSoon until LAUNCH_DATE, admins see the real site with a preview banner.
const Public = ({ children }) => <MaintenanceGuard>{children}</MaintenanceGuard>;

const TOAST_OPTIONS = { style: { fontFamily: 'Lato, sans-serif' } };

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Public><Home /></Public>} />
                        <Route path="/actualites/:slug" element={<Public><Article /></Public>} />
                        <Route path="/rendez-vous" element={<Public><Booking /></Public>} />
                        {/* Cancel link must remain accessible to clients regardless of maintenance mode */}
                        <Route path="/mentions-legales" element={<Public><LegalNotice /></Public>} />
                        <Route path="/confidentialite" element={<Public><PrivacyPolicy /></Public>} />
                        <Route path="/annuler/:token" element={<Cancel />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="*" element={<Public><Home /></Public>} />
                    </Routes>
                    <CookieBanner />
                </BrowserRouter>
            </AuthProvider>
            <Toaster
                position="top-right"
                richColors
                closeButton
                toastOptions={TOAST_OPTIONS}
            />
        </div>
    );
}

export default App;
